export default __webpack_public_path__ + "static/img-channel-thumbnail-third-25a297efd5baedac79cbdea7275e1d75.avif";